type CampaignRecipientVariable = {
  key: string;
  value: string | null;
};
export const getPrimaryEmail = (
  entries: CampaignRecipientVariable[],
): string => {
  return entries.find((entry) => entry.key === "primary_email")?.value ?? "";
};
